import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { clone, isEmpty, isNil } from "ramda";

import { ThemeProvider } from "@mui/material/styles";
import { Autocomplete, Button, Checkbox, Chip, MenuItem, Tab, Tabs, TextField } from "@mui/material";

import palette from "../../../config/colorPalette";
import { getMuiTheme, menuAccessVerification } from "../../utils/utils";
import { BOOLEAN_MEASURES } from "../../utils/consts";
import { setSelectedMenuOptionAction } from "../../redux/menuSlice";
import NormalDataVisualization from "./components/NormalDataVisualization";
import AddTraceModal from "./components/AddTraceModal";
import {
  handleModalAccept,
  //loadBooleanData,
  loadData,
  //loadDateOptions,
  initialSpatialSelectHandler,
  loadDateOptionsChannel,
  IconDisplay,
  reportFiling,
  manageAlertsAndReports,
  getPointsMap,
  getCurrentIntensityData,
  //loadDateOptions,
} from "./utils";
import BooleanDataVisualization from "./components/BooleanDataVisualization";
import { scaleLinear, interpolateRgb } from "d3";
// eslint-disable-next-line no-unused-vars
import {
  getAlertAdditionalInfo,
  getAllAlertsData,
  getAssetPointsAdditionalData,
  getAssetsValuesByAssets,
  getChunkInfo,
  getPointsByAssets,
} from "../../api";
import { setAssetsPointsData } from "../../redux/assetsPointsSlice";
import { setAssetsData } from "../../redux/assetsValuesSlice";
//import ExportToWord from "./components/ExportToWord";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, parseISO } from "date-fns";
import MapAlert from "./components/MapAlert";
import Carousel from "react-material-ui-carousel";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import noImage from "../../../../src/images/no-image.png";
import CurrentIntensityVisualization from "./components/CurrentIntensityVisualization";
import { TabContext, TabPanel } from "@mui/lab";
import DownloadIcon from "@mui/icons-material/Download";
const Analysis = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const userData = useSelector((state) => state.userData.data);
  const menuData = useSelector((state) => state.menuData.data);
  const assetsData = useSelector((state) => state.assetsData.data);
  const assetsPoints = useSelector((state) => state.assetsPoints);
  const configData = useSelector((state) => state.configData.data);
  const {
    assetName,
    equipmentID,
    channelParam,
    dateTime,
    startPointIndex,
    endPointIndex,
    startDate,
    alertMeasure,
    // eslint-disable-next-line no-unused-vars
    alertEvent,
  } = useParams();
  let auxAlertMeasure = alertMeasure;
  const [afterAlert, setAfterAlert] = useState(false);
  const [temporalData, setTemporalData] = useState();
  const [minsW, setMinsW] = useState([]);
  const [maxsW, setMaxsW] = useState([]);
  const [startIndex, setStartIndex] = useState();
  const [endIndex, setEndIndex] = useState();

  const [loading, setLoading] = useState(true);
  const [loadingTemporal, setLoadingTemporal] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [asset, setAsset] = useState();
  const [assetModule, setAssetModule] = useState();
  const [assetEvent, setAssetEvent] = useState();
  const [alertsList, setAlertsList] = useState();
  const [assetAlerts, setAssetAlerts] = useState();
  // eslint-disable-next-line no-unused-vars
  const [eventAlerts, setEventAlerts] = useState();
  const [selectedAlert, setSelectedAlert] = useState();
  const [alertAdditionalInfo, setAlertAdditionalInfo] = useState();
  // eslint-disable-next-line no-unused-vars
  const [selectedAdditionalInfo, setSelectedAdditionalInfo] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [chunk, setChunk] = useState();
  const [disabled, setDisabled] = useState(false);
  const [report, setReport] = useState();
  const [value, setValue] = useState(1);
  const [loadingReport, setLoadingReport] = useState(false);
  const [reportImages, setReportImages] = useState();
  const [reportFiles, setReportFiles] = useState();
  const [firstTime, setFirstTime] = useState(true);
  const [assetEquipments, setAssetEquipments] = useState();
  const [selectedEquipment, setSelectedEquipment] = useState();
  const [equipment, setEquipment] = useState(null);
  const [equipmentChannels, setEquipmentChannels] = useState();
  const [equipmentSubs, setEquipmentSubs] = useState();
  const [asignedChannels, setAsignedChannels] = useState();
  const [asignedChannelNames, setAsignedChannelNames] = useState();
  const [channel, setChannel] = useState();
  const [substructure, setSubstructure] = useState();
  const [axisKeys, setAxisKeys] = useState();
  const [dateTimeList, setDateTimeList] = useState([]);
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [alertTimes, setAlertTimes] = useState([]); // Variable auxiliar para manejar todas las horas de las alertas de un activo
  const [dateOptions, setDateOptions] = useState([]);
  const [dateOptionsModal, setDateOptionsModal] = useState([]);
  const [timeOptions, setTimeOptions] = useState([]);
  const [timeOptionsModal, setTimeOptionsModal] = useState([]);
  const [measuresFiltered, setMeasuresFiltered] = useState([]);
  const [percentiles, setPercentiles] = useState();
  const [differences, setDifferences] = useState();

  const [data, setData] = useState();
  const dataReceivedRef = useRef(false);
  const pointsReceivedRef = useRef(false);
  // eslint-disable-next-line no-unused-vars
  const [booleanData, setBooleanData] = useState();
  const [currentAsset, setCurrentAsset] = useState();
  const [mapColors, setMapColors] = useState();
  // CURRENT INTENSITY CHARTS
  const [assetSensors, setAssetSensors] = useState();
  const [intensityData, setIntesityData] = useState();
  const [loadingIntensity, setLoadingIntensity] = useState(false);
  const [extraFilter, setExtraFilter] = useState([]);

  const refs = useRef([]);
  const params = useParams();

  // Copia los parámetros a un estado local editable
  const [localParams, setLocalParams] = useState({});

  useEffect(() => {
    setLocalParams(params);
  }, [params]);

  const modulesEvents = {
    thermic: ["measurements", "sDoB", "RTTR", "free_spans"],
    dam: ["measurements", "inclinometers", "leaks"],
    railway: [],
    marine: [],
    road: [],
    intrusion: ["manhole", "perimeter"],
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
    //dataReceivedRef.current = false;
    setLoadingReport(true);
    //setAssetModule(event.target.value);
    const reportId = selectedAlert.reports[newValue - 1].id;
    reportFiling({
      id: reportId,
      setReport,
      setReportImages,
      setReportFiles,
      setLoading: setLoadingReport,
    });
  };
  const theme = useMemo(() => getMuiTheme(), []);

  const enabledDates = useMemo(() => {
    if (!isNil(dateOptions) && !isEmpty(dateOptions)) {
      return dateOptions;
    }
  }, [dateOptions]);

  const shouldDisableDate = (date) => {
    // Convertir la fecha a una cadena de fecha sin hora para compararla con las fechas habilitadas
    const dateString = format(date, "yyyy-MM-dd");
    return !enabledDates.some((enabledDate) => enabledDate === dateString);
  };

  useEffect(() => {
    if (menuAccessVerification("/analysis", menuData, navigate)) {
      const i = menuData.find((m) => m.page === "/analysis").value;
      dispatch(setSelectedMenuOptionAction(i));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuData]);

  useEffect(() => {
    if (!isNil(configData)) {
      setMapColors(configData.colorMaps);
    }
  }, [configData]);

  const sensorExtras = {
    temperature: "meteorological.data",
    humidity: "meteorological.data",
    intensity: "intensity",
    current_intensity: "intensity",
  };
  const normalizeMeasurand = (measurand) => {
    if (measurand.startsWith("current_intensity")) return "current_intensity";
    if (measurand.startsWith("intensity")) return "intensity";
    return measurand;
  };

  useEffect(() => {
    if (!isNil(assetSensors) && !isEmpty(assetSensors)) {
      const newFilters = [];
      for (let indexSensor = 0; indexSensor < assetSensors.length; indexSensor++) {
        const measurands = assetSensors[indexSensor].measurands;
        for (let indexMeasurand = 0; indexMeasurand < measurands.length; indexMeasurand++) {
          const normalized = normalizeMeasurand(measurands[indexMeasurand]);
          if (
            !isNil(sensorExtras[normalized]) &&
            !newFilters.includes(intl.formatMessage({ id: sensorExtras[normalized] }))
          ) {
            newFilters.push(intl.formatMessage({ id: sensorExtras[normalized] }));
          }
        }
      }
      setExtraFilter(newFilters);
    } else {
      setExtraFilter([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetSensors]);

  const scales = useMemo(() => {
    if (!isNil(mapColors) && !isEmpty(mapColors)) {
      const jetDomain = [];
      const jetRange = [];
      const seismicDomain = [];
      const seismicRange = [];
      for (let index = 0; index < mapColors["jet"]["blue"].length; index++) {
        jetDomain.push(mapColors["jet"]["value"][index]);
        const redJET = Math.round(mapColors["jet"]["red"][index] * 255);
        const greenJET = Math.round(mapColors["jet"]["green"][index] * 255);
        const blueJET = Math.round(mapColors["jet"]["blue"][index] * 255);
        const hexJET = rgbToHex(redJET, greenJET, blueJET);
        jetRange.push(interpolateRgb(hexJET)(mapColors["jet"]["value"][index]));
        seismicDomain.push(mapColors["seismic"]["value"][index]);
        const redSEISMIC = Math.round(mapColors["seismic"]["red"][index] * 255);
        const greenSEISMIC = Math.round(mapColors["seismic"]["green"][index] * 255);
        const blueSEISMIC = Math.round(mapColors["seismic"]["blue"][index] * 255);
        const hexSeismic = rgbToHex(redSEISMIC, greenSEISMIC, blueSEISMIC);
        seismicRange.push(interpolateRgb(hexSeismic)(mapColors["seismic"]["value"][index]));
      }
      let result = {
        status: scaleLinear()
          .domain([0, 0.5, 0.7, 0.9])
          .range([
            interpolateRgb("green")(0),
            interpolateRgb("yellow")(0.5),
            interpolateRgb("orange")(0.7),
            interpolateRgb("red")(0.9),
          ]),
        leak: scaleLinear()
          .domain([0, 0.55])
          .range([interpolateRgb("green")(0), interpolateRgb("red")(0.55)]),
        temperature: scaleLinear().domain(jetDomain).range(jetRange),
        landslide: scaleLinear()
          .domain([0, 0.55])
          .range([interpolateRgb("green")(0), interpolateRgb("red")(0.55)]),
        strain: scaleLinear().domain(seismicDomain).range(seismicRange),
      };
      return result;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapColors]);

  function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  }

  function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
  }

  function obtainExtension(file) {
    const parts = file.split(".");
    return parts.length > 1 ? parts.pop().toLowerCase() : "";
  }

  function fileType(extension, fileTypes) {
    if (fileTypes.includes(extension)) {
      return true;
    }
    return null;
  }

  const goToPrevious = async () => {
    setDisabled(true);
    const newIndex = currentIndex === 0 ? alertAdditionalInfo.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    const newChunk = await getChunkInfo(alertAdditionalInfo[newIndex].id);
    setChunk(newChunk.data.data);
    setDisabled(false);
  };

  const goToNext = async () => {
    setDisabled(true);
    const newIndex = currentIndex === alertAdditionalInfo.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
    const newChunk = await getChunkInfo(alertAdditionalInfo[newIndex].id);
    setChunk(newChunk.data.data);
    setDisabled(false);
  };
  useEffect(() => {
    async function initialInfo() {
      if (!isNil(assetsData) && !isEmpty(assetsData) && !isNil(userData) && isNil(asset) && isNil(currentAsset)) {
        const assetInit = !isNil(assetName) ? assetName : assetsData[0].name;
        setAsset(assetInit);
        const alertsListResponse = await getAllAlertsData({ is_archived: false });
        setAlertsList(alertsListResponse.data.data);
        const assetInfo = assetsData?.find((a) => a.name === assetInit);
        if (assetInfo.modules.includes("thermic")) {
          setAssetAlerts();
        } else {
          setAssetAlerts(alertsListResponse.data.data.filter((alert) => alert.asset === assetInit));
        }
        const equipmentInit = !isNil(equipmentID) ? equipmentID : assetInfo.equipments[0].equipmentID;
        const equipment = assetInfo.equipments.find((item) => item.equipmentID === equipmentInit);
        setSelectedEquipment(equipment);
        setEquipment(equipmentInit);
        setAssetEquipments(assetInfo.equipments);
        const menuItems = [];
        for (let index = 0; index < equipment.channels.length; index++) {
          menuItems.push(index + 1);
        }
        setAsignedChannels(equipment.channels);
        setAsignedChannelNames(equipment.channelsNames);
        const moduleInit = !isNil(alertMeasure) && alertMeasure !== "measures" ? alertMeasure : assetInfo.modules[0];
        setAssetModule(moduleInit);
        const print = !isNil(channelParam) ? parseInt(channelParam) : equipment.channelsStates.indexOf(true) + 1;
        setChannel(print);
        setEquipmentChannels(menuItems);
      }
    }
    initialInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetsData, userData]);
  useEffect(() => {
    async function setInfo() {
      if (!isNil(asset) && !isNil(assetsData)) {
        const assetInfo = assetsData?.find((a) => a.name === asset);
        //loadDateOptions({
        //  setDateOptions,
        //  setTimeOptions,
        //  asset,
        //  setDate,
        //  setTime,
        //});
        if (assetInfo.modules.includes("thermic") || assetInfo.modules.includes("dam")) {
          setAssetAlerts();
        } else {
          if (!isNil(alertsList) && !isEmpty(alertsList)) {
            setAssetAlerts(alertsList.filter((alert) => alert.asset === asset));
          }
        }
        if (!isNil(assetEquipments) && asset !== assetEquipments[0].asset) {
          setEquipment(assetInfo.equipments[0].equipmentID);
          const equipment = assetInfo.equipments.find(
            (item) => item.equipmentID === assetInfo.equipments[0].equipmentID,
          );
          setSelectedEquipment(equipment);
          setAssetEquipments(assetInfo.equipments);
          const menuItems = [];
          for (let index = 0; index < assetInfo.equipments[0].channels.length; index++) {
            menuItems.push(index + 1);
          }
          setEquipmentSubs(assetInfo.equipments[0].channelsSubStructures);
          setAsignedChannels(equipment.channels);
          setAsignedChannelNames(equipment.channelsNames);
          setAssetModule(assetInfo.modules[0]);
          setChannel(null);
          setSubstructure(null);
          setEquipmentChannels(menuItems);
          setDateTimeList([]);
          setIntesityData();
        }

        //setPoints(response.data);
        //const response2 = await getAssetsValuesByAssets(asset);
        //setAssetsValues(response2.data);
        //dispatch(setAssetsData(response2.data));
      }
    }
    setInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asset, assetsData]);

  useEffect(() => {
    async function getTimes() {
      if (!isNil(asset)) {
        setIntesityData();
        if (channel === null) {
          const print = selectedEquipment.channelsStates.indexOf(true);
          setChannel(print + 1);
          if (print >= 0) {
            setSubstructure(selectedEquipment.channelsSubStructures[print][0].name);
          }
        }
        if (assetModule === "thermic" || assetModule === "dam") {
          loadDateOptionsChannel({
            setDateOptions,
            setDateOptionsModal,
            setTimeOptions,
            setTimeOptionsModal,
            assetEquipments,
            equipmentChannels,
            asset,
            equipment: selectedEquipment,
            channel,
            dateTime,
            setDate,
            setTime,
            setChannel,
            setSubstructure,
            firstTime,
            setFirstTime,
            selectedEquipment,
            setSelectedEquipment,
          });
        }
      }
    }
    getTimes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel]);

  useEffect(() => {
    if (!isNil(assetAlerts) && !isEmpty(assetAlerts) && !isNil(assetModule)) {
      manageAlertsAndReports({
        assetAlerts,
        modulesEvents,
        setSelectedAlert,
        assetModule,
        actualEvent:
          !isNil(localParams) && !isNil(localParams.alertEvent)
            ? localParams.alertEvent
            : modulesEvents[assetModule][0],
        dateTime: !isNil(localParams) && !isNil(localParams.dateTime) ? localParams.dateTime : dateTime,
        setAlertTimes,
        setAssetEvent,
        setEventAlerts,
        setReport,
        setReportImages,
        setReportFiles,
        setDate,
        setTime,
        setDateOptions,
        setTimeOptions,
        setDateOptionsModal,
        setTimeOptionsModal,
        setAlertAdditionalInfo,
        setSelectedAdditionalInfo,
        setChunk,
        setLoading,
      });
      getPointsMap({ asset, assetsPoints, dispatch, setAssetsPointsData });
      setLocalParams(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetAlerts]);

  useEffect(() => {
    if (!isNil(date) && !isNil(time) && !isNil(dateOptions) && !isNil(timeOptions)) {
      const newDateTime = `${dateOptions[date]}T${timeOptions[time]}`;
      if (!isNil(dateTimeList)) {
        setDateTimeList([[newDateTime, channel]]);
      }
    } else {
      setData({});
      dispatch(setAssetsPointsData({}));
      dispatch(setAssetsData({}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, time, dateOptions, timeOptions]);
  useEffect(() => {
    async function getDataAndPoints() {
      const alreadyPoints = assetsPoints.data;
      if (!isNil(alreadyPoints)) {
        const puntosExistentes = (alreadyPoints, asset) => {
          return Object.keys(alreadyPoints).some((key) => key.startsWith(asset));
        };
        if (!puntosExistentes(alreadyPoints, asset) && !isNil(asset)) {
          const response = await getPointsByAssets(asset);
          const pointsMap = {};
          for (let index = 0; index < response.data.data.length; index++) {
            pointsMap[`${asset}${index + 1}`] = response.data.data[index];
          }
          dispatch(setAssetsPointsData(pointsMap));
        }
      }
      if (
        !isNil(asset) &&
        !isNil(dateTimeList) &&
        !isEmpty(dateTimeList) &&
        !isNil(assetsData) &&
        !isNil(selectedEquipment) &&
        !isNil(assetsPoints.data) &&
        !isEmpty(assetsPoints.data) &&
        !dataReceivedRef.current &&
        !isNil(assetsPoints.data[`${asset}${asignedChannels[channel - 1] + 1}`])
      ) {
        dataReceivedRef.current = true;
        const assetInfo = assetsData?.find((a) => a.name === asset);
        loadData({
          asset: assetInfo,
          selectedEquipment,
          points: assetsPoints.data,
          dateTimeList,
          data,
          equipment_ID: equipment,
          channel: channel,
          substructure,
          asignedChannels,
          setData,
          setBooleanData,
          setLoading,
          setPercentiles,
          setDifferences,
          setAxisKeys,
        });
        if (isNil(currentAsset) || currentAsset.name !== asset) {
          const thisAsset = assetsData.find((a) => a.name === asset);
          if (!isNil(thisAsset)) {
            setCurrentAsset(thisAsset);
            setAssetSensors(thisAsset.sensors);
          }
        }
      }
    }
    if (assetModule === "thermic" || assetModule === "dam") {
      getDataAndPoints();
    } else {
      if (!isNil(assetsData) && !isEmpty(assetsData) && (isNil(currentAsset) || currentAsset.name !== asset)) {
        const thisAsset = assetsData.find((a) => a.name === asset);
        if (!isNil(thisAsset)) {
          setCurrentAsset(thisAsset);
          setAssetSensors(thisAsset.sensors);
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateTimeList, assetsPoints]);

  useEffect(() => {
    let start = null;
    let end = null;
    if (
      !isNil(data) &&
      !isEmpty(data) &&
      !isNil(selectedEquipment?.pMeasureNames) &&
      !isNil(dateTimeList) &&
      !isEmpty(dateTimeList) &&
      dateTimeList.length === 1
    ) {
      const m = selectedEquipment.pMeasureNames.find(
        (x) => !isNil(data[0]?.[x]?.values) && !isEmpty(data[0]?.[x].values),
      );

      if (isNil(startPointIndex) && isNil(endPointIndex)) {
        setLoadingTemporal(false);
      }
      if (!isNil(startPointIndex) || (!isNil(startPointIndex) && isNil(endPointIndex))) {
        start = parseInt(startPointIndex);
        setStartIndex(start);
      }
      if (!isNil(endPointIndex)) {
        end = parseInt(endPointIndex);
        setEndIndex(end);
      }
      if (!isNil(start) && !isNil(end)) {
        const spatialDataList = data.map((d) => (!isNil(d[m]) ? { ...d[m], pk: d.pk } : {}));
        const series = spatialDataList?.map((d) => ({
          name: d.datetime,
          data: d.values,
        }));
        initialSpatialSelectHandler({
          data: { series },
          start: start,
          end: end,
          measureName: m,
          setTemporalDataList: setTemporalData,
          minsWaterfall: minsW,
          setMinsWaterfall: setMinsW,
          maxsWaterfall: maxsW,
          setMaxsWaterfall: setMaxsW,
          currentAsset,
          spatialDataList,
          setLoading: setLoadingTemporal,
          dateTime,
          selectedEquipment,
          equipment,
          channel,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startPointIndex, endPointIndex, data, currentAsset, dateTimeList]);
  if (isEmpty(assetsData)) {
    return (
      <div style={{ height: "92vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        {`${intl.formatMessage({ id: "no.data" })}.`}
      </div>
    );
  }
  if (isNil(assetsData) || isNil(data) || loading) {
    const message =
      isNil(dateOptions) &&
      isNil(timeOptions) &&
      isNil(dateOptionsModal) &&
      isNil(timeOptionsModal) &&
      isNil(date) &&
      isNil(time)
        ? "data.didnt.came"
        : "loading";

    return (
      <div style={{ height: "92vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        {`${intl.formatMessage({ id: message })}`}
        {message === "data.didnt.came" && !isNil(assetsData) && isNil(data.length) ? (
          <>
            {` ${intl.formatMessage({ id: "select.another.asset" })}`}
            <TextField
              variant="outlined"
              margin="dense"
              id="asset"
              label={intl.formatMessage({ id: "Asset" })}
              select
              style={{ width: 150, margin: "1%" }}
              value={asset}
              onChange={(event) => {
                pointsReceivedRef.current = false;
                dataReceivedRef.current = false;
                setLoading(true);
                setFirstTime(true);
                setAsset(event.target.value);
              }}
            >
              {assetsData.map((opt) => (
                <MenuItem key={opt.name} value={opt.name}>
                  {opt.name}
                </MenuItem>
              ))}
            </TextField>
          </>
        ) : null}
        {message === "loading" && "..."}
      </div>
    );
  }

  if (!isNil(assetsData) && !loading) {
    return (
      <>
        <ThemeProvider theme={theme}>
          <div style={{ width: "100%", height: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "0.5rem",
                padding: "1rem",
                width: "99%",
              }}
            >
              <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
                <TextField
                  variant="outlined"
                  margin="dense"
                  id="asset"
                  label={intl.formatMessage({ id: "Asset" })}
                  select
                  style={{ width: 150 }}
                  value={asset}
                  onChange={(event) => {
                    pointsReceivedRef.current = false;
                    dataReceivedRef.current = false;
                    setLoading(true);
                    setFirstTime(true);
                    setAsset(event.target.value);
                  }}
                >
                  {assetsData.map((opt) => (
                    <MenuItem key={opt.name} value={opt.name}>
                      {opt.name}
                    </MenuItem>
                  ))}
                </TextField>
                {!isNil(currentAsset) && !isNil(currentAsset?.modules) && currentAsset?.modules.length > 1 && (
                  <TextField
                    variant="outlined"
                    margin="dense"
                    id="module"
                    label={intl.formatMessage({ id: "module" })}
                    select
                    style={{ width: 150 }}
                    value={assetModule}
                    onChange={(event) => {
                      dataReceivedRef.current = false;
                      setLoading(true);
                      const assetInfo = assetsData?.find((a) => a.name === asset);
                      const equipment = assetInfo.equipments.find((item) => item.equipmentID === event.target.value);
                      setSelectedEquipment(equipment);
                      setAsignedChannels(equipment.channels);
                      setAsignedChannelNames(equipment.channelsNames);
                      setChannel(null);
                      setTimeout(() => {
                        setEquipment(event.target.value);
                        const print = equipment.channelsStates.indexOf(true);
                        setChannel(print + 1);
                        setSubstructure(equipment.channelsSubStructures[print][0].name);
                      }, 0);
                      setAssetModule(event.target.value);
                    }}
                  >
                    {currentAsset?.modules.map((cModule, moduleIndex) => (
                      <MenuItem key={`${cModule}_${moduleIndex}`} value={cModule}>
                        {intl.formatMessage({ id: cModule })}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
                {(assetModule === "thermic" || assetModule === "dam") && (
                  <>
                    {!isNil(assetEquipments) && assetEquipments.length > 1 && (
                      <TextField
                        select
                        style={{ width: 150 }}
                        id="asset_equipments"
                        variant="outlined"
                        label={intl.formatMessage({ id: "equipments" })}
                        margin="dense"
                        value={equipment}
                        onChange={(event) => {
                          dataReceivedRef.current = false;
                          setLoading(true);
                          const assetInfo = assetsData?.find((a) => a.name === asset);
                          const equipment = assetInfo.equipments.find(
                            (item) => item.equipmentID === event.target.value,
                          );
                          setSelectedEquipment(equipment);
                          setAsignedChannels(equipment.channels);
                          setAsignedChannelNames(equipment.channelsNames);
                          setChannel(null);
                          setTimeout(() => {
                            setEquipment(event.target.value);
                            const print = equipment.channelsStates.indexOf(true);
                            setChannel(print + 1);
                            setSubstructure(equipment.channelsSubStructures[print][0].name);
                          }, 0);
                        }}
                      >
                        {assetEquipments.map((ae, i) => (
                          <MenuItem key={`${ae.equipmentID}_current_select_${i}`} value={ae.equipmentID}>
                            {ae.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}

                    {!isNil(equipmentSubs) && !isNil(channel) && !isNil(substructure) && (
                      <TextField
                        select
                        style={{ width: 150 }}
                        id="equipments_channels_sub"
                        variant="outlined"
                        label={intl.formatMessage({ id: "channel" })}
                        margin="dense"
                        value={`${channel}-${substructure}`}
                        onChange={(event) => {
                          dataReceivedRef.current = false;
                          const [newChannel, ...newSubstructureParts] = event.target.value.split("-");
                          const newSubstructure = newSubstructureParts.join("-");
                          setChannel(parseInt(newChannel, 10));
                          setSubstructure(newSubstructure);
                        }}
                      >
                        {
                          // eslint-disable-next-line array-callback-return
                          equipmentSubs.map((subsChannel, channelIndex) => {
                            const print = selectedEquipment.channelsStates[channelIndex];
                            if (!print) {
                              return null;
                            }
                            if (!isEmpty(subsChannel)) {
                              return subsChannel.map((sub, subIndex) => (
                                <MenuItem
                                  key={`${subIndex}_current_sub_${channelIndex}`}
                                  value={`${channelIndex + 1}-${sub.name}`}
                                >
                                  {asignedChannelNames[channelIndex]} - {sub.name}
                                </MenuItem>
                              ));
                            }
                          })
                        }
                      </TextField>
                    )}
                  </>
                )}

                {assetModule === "intrusion" && (
                  <>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      id="events"
                      label={intl.formatMessage({ id: "event" })}
                      select
                      style={{ width: 150 }}
                      value={assetEvent}
                      onChange={(event) => {
                        dataReceivedRef.current = false;
                        setLoading(true);
                        manageAlertsAndReports({
                          assetAlerts,
                          modulesEvents,
                          setSelectedAlert,
                          assetModule,
                          actualEvent: event.target.value,
                          setAlertTimes,
                          setAssetEvent,
                          setEventAlerts,
                          setReport,
                          setReportImages,
                          setReportFiles,
                          setDate,
                          setTime,
                          setDateOptions,
                          setTimeOptions,
                          setDateOptionsModal,
                          setTimeOptionsModal,
                          setAlertAdditionalInfo,
                          setSelectedAdditionalInfo,
                          setChunk,
                          setLoading,
                        });
                        //setAssetModule(event.target.value);
                      }}
                    >
                      <MenuItem key={`manholes_intrusion`} value={"manhole"}>
                        {intl.formatMessage({ id: "manholes" })}
                      </MenuItem>
                      <MenuItem key={`perimeters_intrusion`} value={"perimeter"}>
                        {intl.formatMessage({ id: "perimeters" })}
                      </MenuItem>
                    </TextField>
                  </>
                )}

                {!isEmpty(dateOptions) && !isNil(dateOptions) && (
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      id="date_picker"
                      label={intl.formatMessage({ id: "date" })}
                      sx={{ marginTop: "0.5%" }}
                      shouldDisableDate={shouldDisableDate}
                      format="dd-MM-yyyy"
                      value={parseISO(dateOptions[date])}
                      onChange={async (e) => {
                        dataReceivedRef.current = false;
                        setLoading(true);
                        const date = new Date(e);

                        const year = date.getFullYear();
                        const month = ("0" + (date.getMonth() + 1)).slice(-2);
                        const day = ("0" + date.getDate()).slice(-2);

                        const formattedDate = year + "-" + month + "-" + day;
                        if (assetModule === "thermic" || assetModule === "dam") {
                          loadDateOptionsChannel({
                            //setDateOptions,
                            setTimeOptions,
                            date: dateOptions[dateOptions.indexOf(formattedDate)],
                            dateOptions,
                            assetEquipments,
                            asset,
                            equipment,
                            channel,
                            equipmentChannels,
                            setDate,
                            setTime,
                            firstTime,
                            setFirstTime,
                            selectedEquipment,
                            setSelectedEquipment,
                          });
                        }
                        if (assetModule === "intrusion") {
                          const indexDate = dateOptions.indexOf(formattedDate);
                          setDate(indexDate);
                          setTimeOptions(alertTimes[indexDate]);
                          setTimeOptionsModal(alertTimes[indexDate]);
                          const newFormattedDate = `${dateOptions[indexDate]}T${alertTimes[indexDate][0]}`;
                          const actualAlert = assetAlerts.find(
                            (alert) =>
                              alert.dateStart === newFormattedDate ||
                              alert.dateStart === `${dateOptions[indexDate]} ${alertTimes[indexDate][0]}`,
                          );
                          const newAdditionalInfo = await getAlertAdditionalInfo(actualAlert.id);
                          setAlertAdditionalInfo(newAdditionalInfo.data.data); // esto se setea para conseguir los chunks
                          if (!isEmpty(newAdditionalInfo.data.data)) {
                            setSelectedAdditionalInfo(newAdditionalInfo.data.data[0].id);
                            const newChunk = await getChunkInfo(newAdditionalInfo.data.data[0].id);
                            setChunk(newChunk.data.data);
                          } else {
                            setSelectedAdditionalInfo(null);
                            setChunk([]);
                          }
                          if (!isEmpty(actualAlert.reports)) {
                            setTime(0);
                            setSelectedAlert(actualAlert);
                            let reportIndex = null;
                            for (let alertRepIndex = 0; alertRepIndex < actualAlert.reports.length; alertRepIndex++) {
                              if (
                                !isNil(actualAlert.reports[alertRepIndex]) &&
                                !isEmpty(actualAlert.reports[alertRepIndex])
                              ) {
                                reportIndex = alertRepIndex;
                                break;
                              }
                            }
                            if (!isNil(reportIndex)) {
                              reportFiling({
                                id: actualAlert.reports[reportIndex].id,
                                setReport,
                                setReportImages,
                                setReportFiles,
                                setLoading,
                              });
                            } else {
                              reportFiling({
                                id: actualAlert.reports[0].id,
                                setReport,
                                setReportImages,
                                setReportFiles,
                                setLoading,
                              });
                            }

                            setSelectedAlert(actualAlert);
                          }
                        }
                      }}
                    />
                  </LocalizationProvider>
                )}
                {!isEmpty(timeOptions) && !isNil(timeOptions) && (
                  <TextField
                    variant="outlined"
                    margin="dense"
                    id="trace_date"
                    label={intl.formatMessage({ id: "time" })}
                    select
                    style={{ width: 150 }}
                    value={time}
                    onChange={async (event) => {
                      dataReceivedRef.current = false;
                      setLoading(true);
                      if (assetModule === "thermic" || assetModule === "dam") {
                        setLoading(false);
                      }
                      if (assetModule === "intrusion") {
                        const formattedDate = `${dateOptions[date]}T${timeOptions[event.target.value]}`;
                        const actualAlert = assetAlerts.find(
                          (alert) =>
                            alert.dateStart === formattedDate ||
                            alert.dateStart === `${dateOptions[date]} ${timeOptions[event.target.value]}`,
                        );
                        const newAdditionalInfo = await getAlertAdditionalInfo(actualAlert.id);
                        setAlertAdditionalInfo(newAdditionalInfo.data.data); // esto se setea para conseguir los chunks
                        if (!isEmpty(newAdditionalInfo.data.data)) {
                          setSelectedAdditionalInfo(newAdditionalInfo.data.data[0].id);
                          const newChunk = await getChunkInfo(newAdditionalInfo.data.data[0].id);
                          setChunk(newChunk.data.data);
                        } else {
                          setSelectedAdditionalInfo(null);
                          setChunk([]);
                        }
                        if (!isEmpty(actualAlert.reports)) {
                          setSelectedAlert(actualAlert);
                          reportFiling({
                            id: actualAlert.reports[0].id,
                            setReport,
                            setReportImages,
                            setReportFiles,
                            setLoading,
                          });
                        } else {
                          setSelectedAlert(actualAlert);
                          setReport(null);
                          setReportFiles(null);
                        }
                      }
                      setTime(event.target.value);
                    }}
                  >
                    {timeOptions?.map((opt, i) => (
                      <MenuItem key={`times-${i}`} value={i}>
                        {opt.replace(/\.\d+(?=\+)/, "")}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              </div>
              {!isNil(selectedEquipment) && (assetModule === "thermic" || assetModule === "dam") && (
                <Autocomplete
                  multiple
                  id="multiple-checkboxes"
                  options={
                    isEmpty(assetSensors)
                      ? selectedEquipment.pMeasureNames
                      : [...selectedEquipment.pMeasureNames, ...extraFilter]
                  }
                  disableCloseOnSelect
                  onChange={(event, values) => {
                    if (
                      !isEmpty(assetSensors) &&
                      (values.includes(intl.formatMessage({ id: "intensity" })) ||
                        values.includes(intl.formatMessage({ id: "meteorological.data" })))
                    ) {
                      getCurrentIntensityData({
                        asset,
                        assetSensors,
                        afterAlert,
                        channel,
                        data,
                        dateTimeList,
                        endIndex,
                        equipment,
                        selectedEquipment,
                        setIntesityData,
                        startDate,
                        startIndex,
                        setLoadingIntensity,
                      });
                    } else {
                      setIntesityData();
                    }
                    let newValues = clone(values);
                    let aux = [];
                    if (newValues.includes(intl.formatMessage({ id: "intensity" }))) {
                      aux.push(newValues.indexOf(intl.formatMessage({ id: "intensity" })));
                    }
                    if (newValues.includes(intl.formatMessage({ id: "meteorological.data" }))) {
                      aux.push(newValues.indexOf(intl.formatMessage({ id: "meteorological.data" })));
                    }
                    if (!isNil(aux) && !isEmpty(aux)) {
                      const indexOf = Math.max(aux);
                      newValues = newValues.splice(0, indexOf);
                    }
                    setMeasuresFiltered(newValues);
                  }}
                  getOptionLabel={(option) => option}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox style={{ marginRight: 8 }} checked={selected} />
                      {intl.formatMessage({ id: option })}
                    </li>
                  )}
                  style={{ width: 300 }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" label={intl.formatMessage({ id: "select.graphs" })} />
                  )}
                />
              )}
              {/*!isNil(refs.current) && !isEmpty(refs.current) && !isNil(currentAsset) && (
              <ExportToWord
                asset={asset}
                date={dateOptions[date]}
                time={timeOptions[time]}
                charts={currentAsset.pMeasureNames.map((m, i) => ({ title: m, ref: refs.current[i] }))}
              />
            )*/}
              {(assetModule === "thermic" || assetModule === "dam") && (
                <Button
                  variant="contained"
                  style={{ height: "2.5rem", backgroundColor: palette.primary, color: "white" }}
                  size="small"
                  onClick={() => setOpenModal(true)}
                >
                  {intl.formatMessage({ id: "add reading" })}
                </Button>
              )}
            </div>
            <div
              style={{
                display: "grid",
                gap: "1rem",
                overflowY: "scroll",
                overflowX: "hidden",
                width: "98%",
                height: "75vh",
              }}
            >
              {(assetModule === "thermic" || assetModule === "dam") && (
                <>
                  {!isNil(dateTimeList) && !isEmpty(dateTimeList) && !isNil(selectedEquipment) ? (
                    // eslint-disable-next-line array-callback-return
                    selectedEquipment.pMeasureNames.map((m, i) => {
                      if (measuresFiltered.includes(m) || measuresFiltered.length === 0) {
                        return BOOLEAN_MEASURES.includes(m) ? (
                          <div
                            style={{
                              position: "relative",
                              width: "99%",
                            }}
                            ref={(ref) => (refs.current[i] = ref)}
                          >
                            {!isNil(booleanData) && !isEmpty(booleanData) ? (
                              <BooleanDataVisualization
                                key={`${asset}-boolean-${m}-${i}`}
                                data={booleanData.map((d) => (!isNil(d[m]) ? { ...d[m], pk: d.pk } : {}))}
                                measureName={m}
                                assetName={asset}
                                asignedChannels={asignedChannels}
                                currentAsset={currentAsset}
                                title={m}
                                assetsPoints={assetsPoints}
                                initialPointIndex={startIndex ?? 0}
                                endPointIndex={endIndex ?? booleanData?.[0]?.[m]?.values?.length - 1}
                                loadingTemporal={loadingTemporal}
                                scales={scales}
                                percentiles={percentiles}
                                differences={differences}
                                equipment={equipment}
                                channel={channel}
                                selectedEquipment={selectedEquipment}
                              />
                            ) : (
                              <div
                                style={{
                                  width: "100%",
                                  height: "20rem",
                                  backgroundColor: "rgb(176 176 176 / 60%)",
                                  zIndex: 1000,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexDirection: "column",
                                  margin: "1rem",
                                  padding: "0.5rem",
                                  gap: "1rem",
                                }}
                              >
                                {`${intl.formatMessage({ id: "loading" })}...`}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div
                            style={{
                              position: "relative",
                              width: "99%",
                            }}
                            ref={(ref) => (refs.current[i] = ref)}
                          >
                            {!isNil(data) && !isEmpty(data) && !isNil(m) ? (
                              <NormalDataVisualization
                                key={`${asset}-normal-${m}-${i}`}
                                data={data.map((d) => (!isNil(d[m]) ? { ...d[m], pk: d.pk } : {}))}
                                currentAsset={currentAsset}
                                assetName={asset}
                                asignedChannels={asignedChannels}
                                title={m}
                                measureName={m}
                                //boundaries={currentAsset.pBoundaries[i]}
                                initialPointIndex={startIndex ?? 0}
                                endPointIndex={endIndex ?? data?.[0]?.[m]?.values?.length - 1}
                                assetsPoints={assetsPoints}
                                temporalData={temporalData?.[m]}
                                maxsW={maxsW}
                                minsW={minsW}
                                isAlert={!isNil(dateTime)}
                                loadingTemporal={loadingTemporal}
                                datetime={dateTimeList.length > 1 ? dateTimeList[date][0] : dateTimeList[0][0]}
                                dateTimeList={dateTimeList}
                                scales={scales}
                                percentiles={percentiles}
                                differences={differences}
                                equipment={equipment}
                                channel={channel}
                                selectedEquipment={selectedEquipment}
                                colorMaps={configData.colorMaps}
                                alertMeasure={auxAlertMeasure}
                                startDate={startDate}
                                afterAlert={afterAlert}
                                setAfterAlert={setAfterAlert}
                                substructure={substructure}
                                axisKeys={axisKeys}
                                setAxisKeys={setAxisKeys}
                              />
                            ) : (
                              <div
                                style={{
                                  width: "100%",
                                  height: "20rem",
                                  backgroundColor: "rgb(176 176 176 / 60%)",
                                  zIndex: 1000,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexDirection: "column",
                                  margin: "1rem",
                                  padding: "0.5rem",
                                  gap: "1rem",
                                }}
                              >
                                {`${intl.formatMessage({ id: isEmpty(data) ? "no.data" : "loading" })}...`}
                              </div>
                            )}
                          </div>
                        );
                      }
                    })
                  ) : (
                    <div
                      style={{ height: "50vh", display: "flex", justifyContent: "center", alignItems: "center" }}
                    >{`${intl.formatMessage({ id: "loading" })}...`}</div>
                  )}
                </>
              )}
              {assetModule === "intrusion" && (
                <div style={{ marginLeft: "1%", marginRight: "1%", position: "relative" }}>
                  {!isNil(selectedAlert) ? (
                    <div
                      style={{
                        fontSize: "1.2rem",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: "16px",
                      }}
                    >
                      <div
                        style={{
                          borderRadius: "10px",
                          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                          overflow: "hidden",
                          backgroundColor: palette.primary,
                          width: "45%",
                        }}
                      >
                        <h2 style={{ padding: "2%", color: "white" }}>{intl.formatMessage({ id: "alert.info" })}</h2>
                        <div style={{ padding: "2%", backgroundColor: palette.likeWhite }}>
                          <span style={{ marginTop: "1%" }}>
                            <b>{intl.formatMessage({ id: "channel" })}:</b>{" "}
                            <span>{selectedEquipment.channelsNames[channel - 1]}</span>
                          </span>
                          <br />
                          {!isNil(selectedAlert.eventType) && (
                            <>
                              <span style={{ marginTop: "1%" }}>
                                <b>{intl.formatMessage({ id: "event.type" })}:</b>{" "}
                                <span>{intl.formatMessage({ id: selectedAlert.eventType })}</span>
                              </span>
                              <br />
                            </>
                          )}
                          <span style={{ marginTop: "1%" }}>
                            <b>{intl.formatMessage({ id: "severity" })}:</b> <span>{selectedAlert.severity}</span>
                          </span>
                          <br />
                          <span style={{ marginTop: "1%" }}>
                            <b>{intl.formatMessage({ id: "start.date" })}:</b>{" "}
                            <span>{selectedAlert.dateStart.replace(/\.\d+(?=\+)/, "").replace("T", " ")}</span>
                          </span>
                          <br />
                          <span style={{ marginTop: "1%" }}>
                            <b>{intl.formatMessage({ id: "end.date" })}:</b>{" "}
                            <span>{selectedAlert.dateEnd.replace(/\.\d+(?=\+)/, "").replace("T", " ")}</span>
                          </span>
                          <br />
                          {!isNil(report) && !isEmpty(report) && (
                            <span style={{ marginTop: "1%" }}>
                              <b>{intl.formatMessage({ id: "description" })}:</b> <span>{report.content}</span>
                            </span>
                          )}
                        </div>
                      </div>
                      <MapAlert assetData={currentAsset} points={assetsPoints} alert={selectedAlert} intl={intl} />
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgb(176 176 176 / 60%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        position: "absolute",
                      }}
                    >{`${intl.formatMessage({ id: "no.alert" })}`}</div>
                  )}

                  <br />
                  {!isNil(report) && (
                    <TabContext value={value}>
                      <Tabs value={value} onChange={handleChange} style={{ backgroundColor: "rgb(211, 211, 208)" }}>
                        {selectedAlert.reports.map((report, reportIndex) => (
                          <Tab
                            id={`tab${reportIndex}`}
                            value={reportIndex + 1}
                            label={`${intl.formatMessage({ id: "report" })} ${reportIndex + 1}`}
                          />
                        ))}
                      </Tabs>

                      <TabPanel
                        sx={{ flex: 1, overflow: "auto", width: "100%", backgroundColor: "rgb(211, 211, 208)" }}
                        value={value}
                      >
                        {!isNil(report) && !isEmpty(report) && (
                          <div style={{ fontSize: "1.2rem", marginBottom: "1rem" }}>
                            <span style={{ marginTop: "1%" }}>
                              <b>{intl.formatMessage({ id: "author" })}:</b>{" "}
                              <span>
                                {report.authorInfo.name}-{report.authorInfo.organization}
                              </span>
                              <br />
                            </span>
                            <span style={{ marginTop: "1%" }}>
                              <b>{intl.formatMessage({ id: "created.at" })}:</b>{" "}
                              <span>{report.createdAt.replace(/\.\d+$/, "").replace("T", " ")}</span>
                            </span>
                            <br />
                            <span style={{ marginTop: "1%" }}>
                              <b>{intl.formatMessage({ id: "last.update" })}:</b>{" "}
                              <span>{report.updatedAt.replace(/\.\d+$/, "").replace("T", " ")}</span>
                            </span>
                            <br />
                          </div>
                        )}
                        {!isNil(reportFiles) && !isNil(reportImages) && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                              gap: "16px",
                            }}
                          >
                            {/* Contenedor de imágenes a la izquierda */}
                            <div style={{ display: "flex", flexDirection: "column", gap: "8px", flex: 1 }}>
                              {!isNil(reportImages) && !isEmpty(reportImages) && (
                                <>
                                  <Carousel
                                    autoPlay={false} // Desactiva el auto-play
                                    navButtonsAlwaysVisible // Mantiene siempre visibles los botones de navegación
                                    indicators={true} // Muestra los indicadores (puntos) en la parte inferior
                                    cycleNavigation={true} // Permite navegación cíclica (del último al primero)
                                    swipe={true}
                                    height="27rem"
                                    NavButton={({ onClick, className, style, next, prev }) => {
                                      // Botones de navegación personalizados
                                      const buttonStyle = {
                                        backgroundColor: "rgba(48, 45, 45, 0.8)",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "50%",
                                        width: "40px",
                                        height: "40px",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                        position: "absolute",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        zIndex: 2,
                                        ...(next && { right: "10px" }),
                                        ...(prev && { left: "10px" }),
                                      };
                                      return (
                                        <button onClick={onClick} className={className} style={buttonStyle}>
                                          {next && ">"}
                                          {prev && "<"}
                                        </button>
                                      );
                                    }}
                                  >
                                    {reportImages?.map((attachment, attachmentIndex) => {
                                      return (
                                        <div
                                          key={`${attachment.filename}_carousel_${attachmentIndex}`}
                                          style={{ position: "relative", display: "inline-block" }}
                                        >
                                          <button
                                            onClick={() => {
                                              // Descargar imagen actual (necesitarías state para el índice actual)
                                              const currentImage = attachment;
                                              const link = document.createElement("a");
                                              link.href = `data:image/png;base64,${currentImage.content}`;
                                              link.download = currentImage.filename;
                                              document.body.appendChild(link);
                                              link.click();
                                              document.body.removeChild(link);
                                            }}
                                            style={{
                                              position: "absolute",
                                              top: "2%",
                                              right: "6%",
                                              zIndex: 9999,
                                              background: "rgba(0,0,0,0.6)",
                                              color: "white",
                                              border: "none",
                                              padding: "5px 10px",
                                              borderRadius: "4px",
                                              cursor: "pointer",
                                              display: "flex", // importante
                                              alignItems: "center", // para centrar el ícono
                                              justifyContent: "center",
                                            }}
                                          >
                                            <DownloadIcon />
                                          </button>
                                          <img
                                            key={`${attachment.filename}_carousel_${attachmentIndex}`}
                                            src={`data:image/png;base64,${attachment.content}`}
                                            alt={`${attachment.filename}`}
                                            width={"825rem"}
                                            style={{ display: "block" }}
                                          />
                                        </div>
                                      );
                                    })}
                                  </Carousel>
                                </>
                              )}
                              {(isNil(reportImages) || isEmpty(reportImages)) && (
                                <center>
                                  <img key={`NO IMAGE CAROUSEL`} src={noImage} alt={`NO FOUND`} width={"400rem"} />
                                </center>
                              )}
                            </div>

                            {/* Contenedor de chips a la derecha con anchura reducida */}
                            <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "50%" }}>
                              {reportFiles?.map((attachment, attachmentIndex) => {
                                const extension = obtainExtension(attachment.filename);
                                const imageChecker = fileType(extension, [
                                  "jpg",
                                  "jpeg",
                                  "png",
                                  "gif",
                                  "bmp",
                                  "svg",
                                  "webp",
                                  "tiff",
                                ]);
                                if (!imageChecker) {
                                  return (
                                    <Chip
                                      key={`${attachment.filename}_${attachmentIndex}`}
                                      label={
                                        <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                          {attachment.filename}
                                          <IconDisplay filename={attachment.filename} fileIndex={attachmentIndex} />
                                        </span>
                                      }
                                    />
                                  );
                                }
                                return null;
                              })}
                            </div>
                          </div>
                        )}
                      </TabPanel>
                    </TabContext>
                  )}
                  {loadingReport && (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgb(176 176 176 / 60%)",
                        zIndex: 2000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        position: "absolute",
                      }}
                    >
                      {`${intl.formatMessage({ id: "loading" })}...`}
                    </div>
                  )}

                  {!isNil(alertAdditionalInfo) && !isEmpty(alertAdditionalInfo) && (
                    <>
                      <h2 style={{ marginTop: "3%", fontSize: "1.2rem" }}>{intl.formatMessage({ id: "raw.data" })}</h2>
                      <div style={{ marginTop: "10px", display: "flex", justifyContent: "center" }}>
                        <Button disabled={disabled} startIcon={<ArrowBackIos />} onClick={goToPrevious} />
                        <h2 style={{ color: palette.primary }}>
                          {currentIndex + 1}/{alertAdditionalInfo.length}
                        </h2>
                        <Button disabled={disabled} startIcon={<ArrowForwardIos />} onClick={goToNext} />
                      </div>
                      {!isNil(chunk) && !isEmpty(chunk) && (
                        <div style={{ overflow: "hidden", position: "relative" }}>
                          <img
                            src={`data:image/png;base64,${chunk}`}
                            alt={chunk + "_image"}
                            style={{ width: "100%", height: "auto", maxWidth: "100vw" }}
                          />
                          {disabled && (
                            <div
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgb(176 176 176 / 60%)",
                                zIndex: 10000,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                              }}
                            >
                              {intl.formatMessage({ id: "loading" })}...
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
              {!isNil(intensityData) && !isEmpty(intensityData) && (
                <CurrentIntensityVisualization
                  intensityData={intensityData}
                  afterAlert={afterAlert}
                  assetSensors={assetSensors}
                  data={data}
                  dateTimeList={dateTimeList}
                  key={`intensity chart`}
                  info={{
                    asset: asset,
                    equipment: selectedEquipment,
                    channel: channel,
                    dateTime: dateTimeList[0][0],
                  }}
                  intl={intl}
                />
              )}
              {loadingIntensity && (
                <div
                  style={{
                    width: "100%",
                    height: "20rem",
                    backgroundColor: "rgb(176 176 176 / 60%)",
                    zIndex: 1000,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    margin: "1rem",
                    padding: "0.5rem",
                    gap: "1rem",
                  }}
                >
                  {`${intl.formatMessage({ id: "loading" })}...`}
                </div>
              )}
            </div>
          </div>
        </ThemeProvider>
        {(assetModule === "thermic" || assetModule === "dam") && (
          <AddTraceModal
            key={`add_trace_modal_${asset}_${equipment}_${channel}`}
            asset={asset}
            equipment={equipment}
            channel={channel}
            open={openModal}
            setOpen={setOpenModal}
            timeOptionsModal={timeOptionsModal}
            dateOptionsModal={dateOptionsModal}
            setTimeOptionsModal={setTimeOptionsModal}
            setDateOptionsModal={setDateOptionsModal}
            equipmentChannels={equipmentChannels}
            asignedChannelNames={asignedChannelNames}
            selectedEquipment={selectedEquipment}
            assetEquipments={assetEquipments}
            assetModule={assetModule}
            firstTime={firstTime}
            setFirstTime={setFirstTime}
            setSelectedEquipment={setSelectedEquipment}
            dataReceivedRef={dataReceivedRef}
            handleModalAccept={(dateIndex, timeIndex, modalChannel) => {
              dataReceivedRef.current = false;
              handleModalAccept({
                date: dateOptionsModal[dateIndex],
                time: timeOptionsModal[timeIndex],
                modalChannel,
                dateTimeList,
                setDateTimeList,
              });
            }}
          />
        )}
      </>
    );
  }
};

export default Analysis;
